export const FETCH_PROVIDERS_STARTED = 'FETCH_PROVIDERS_STARTED';
export const FETCH_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS';
export const FETCH_PROVIDERS_FAILED = 'FETCH_PROVIDERS_FAILED';
